module.exports = __webpack_public_path__ + "img/blog-details-light.5d42fa78.png";